//移動アニメーションJS

(() => {
  const els = document.querySelectorAll('.swaddle_star');
  if (!els.length) return;

  const SPEED_Y = 16;
  const WAVE_SEC = 90;
  const FADE_SEC = 0.8;
  const WAIT_SEC = 0.3;
  const STAGGER_SEC = 1.2;

  const X_RANGE_RATIO = 1.1;

  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
  const getSize = () => window.matchMedia('(max-width: 767px)').matches ? 48 : 96;

  // swaddle_star の「基準コンテナ」（親のrelative要素）を取る
  const getContainer = (el) => el.offsetParent || el.parentElement || document.body;

  const animateOne = (el, delaySec) => {
    let startTime = null;
    let rafId = null;

    const reset = () => {
      startTime = null;
      el.style.opacity = '1';
      el.style.transition = '';
      el.style.transform = 'none';
      el.style.right = '';

      // 初期値
      el.style.left = '0px';
      el.style.top = '0px';
    };

    const fadeAndReset = async () => {
      el.style.transition = `opacity ${FADE_SEC}s linear`;
      el.style.opacity = '0';
      await new Promise(r => setTimeout(r, FADE_SEC * 1000));
      await new Promise(r => setTimeout(r, WAIT_SEC * 1000));
      reset();
      rafId = requestAnimationFrame(tick);
    };

    const tick = (t) => {
      if (startTime === null) startTime = t;
      const elapsed = (t - startTime) / 1000 - delaySec;

      if (elapsed < 0) {
        rafId = requestAnimationFrame(tick);
        return;
      }

      const size = getSize();
      const y = elapsed * SPEED_Y;

      // ✅ 親要素幅を基準に振れ幅を作る
      const container = getContainer(el);
      const cw = container.clientWidth;

      // 「親幅の125%」を移動範囲にする（画像サイズぶん調整）
      const range = cw * X_RANGE_RATIO;
      const xMin = (cw - range) / 2;        // はみ出す分はマイナスになる
      const xMax = xMin + range - size;

      // S字（最初は左へ）
      const phase = (elapsed / WAVE_SEC) * Math.PI * 2 + Math.PI;
      const sin = Math.sin(phase);

      const rawX = ((sin + 1) / 2) * (xMax - xMin) + xMin;

      // ここで clamp しない（はみ出してOKだから）
      const x = rawX;

      el.style.top = `${Math.round(y)}px`;
      el.style.left = `${Math.round(x)}px`;

      // 下まで行ったら消す
      const limit = window.innerHeight + size;
      if (y > limit) {
        cancelAnimationFrame(rafId);
        fadeAndReset();
        return;
      }

      rafId = requestAnimationFrame(tick);
    };

    reset();
    rafId = requestAnimationFrame(tick);
  };

  els.forEach((el, i) => animateOne(el, i * STAGGER_SEC));
})();
